import { useState, useCallback } from 'react';

export type FormMode = 'view' | 'add' | 'edit';

export function usePWP255Mode() {
  const [mode, setMode] = useState<FormMode>('view');

  const toView = useCallback(() => setMode('view'), []);
  const toAdd = useCallback(() => setMode('add'), []);
  const toEdit = useCallback(() => setMode('edit'), []);

  return {
    mode,
    toView,
    toAdd,
    toEdit,
    isEditing: mode === 'add' || mode === 'edit',
  };
}
